export default {
  selectLang: "Sélectionner la langue",
  footer: {
    copyright: "© 2025 TaxEcoBit. Tous droits réservés.",
    terms: "Conditions d'utilisation",
    privacy: "Politique de confidentialité",
    help: "Assistance ou suggestions ?",
  },
  menu: {
    dashboard: "Tableau de bord",
    calculate: "Calculer",
    calculations: "Calculs",
    pricing: "Tarification",
    settings: "Paramètres",
    factors: "Facteurs",
    reports: "Rapports",
    upgrade: "Passer à la version supérieure",
    usage: "Utilisation",
    invite: "Invitations",
    home: "Accueil",
    blog: "Blog",
    whitepaper: "Livre blanc",
    about: "À propos de nous",
    faq: "FAQ",
    terms: "Conditions d'utilisation",
    privacy: "Politique de confidentialité",
    tickets: "Tickets",
    billing: "Facturation",
    "billing-overview": "Aperçu",
    "billing-orders": "Commandes",
    "billing-invoices": "Factures",
    "billing-subscription": "Abonnement",
    templates: "Modèles",
  },
  upgradeWall: {
    successTitle: "Demande d'essai réussie",
    successSubtitle: "Vous avez réussi à demander l'essai gratuit du plan Pro pendant 14 jours",
    quotaTitle: "Quota de calcul :",
    reportQuotaTitle: "Quota de rapports :",
    planComparison: "Comparaison des fonctionnalités des plans",
    calculation: "Calcul",
    report: "Rapport",
    price: "Prix",
    viewPricing: "Voir la tarification complète",
    freeTrial: "Essai gratuit Pro pendant 14 jours",
    upgradeToPro: "Passer à la version Pro",
    upgradePro: "Passer à la version Pro",
    contactSupport: "Contacter l'assistance",
    inviteRewards: "Obtenez plus de quota grâce aux invitations !",
    inviteRewardsDesc:
      "Invitez des amis à s'inscrire, et vous et vos amis recevrez des quotas de calcul supplémentaires",
    inviteFriends: "Inviter des amis",
    quotaExhausted: "Le quota de votre plan a été épuisé",
    calculationThreshold: "Votre quota de calcul a été utilisé à {percent} %",
    reportThreshold: "Votre quota de rapports a été utilisé à {percent} %",
    upgradePlan: "Passer à un plan supérieur",
    free: "Gratuit",
    basic: "49 €/mois",
    proPrice: "99 €/mois",
    timesPerMonth: "fois/mois",
    plan: "Plan",
    trialSuccess: "Demande d'essai réussie",
  },
  ticket: {
    modal_title: "Soumettre un ticket",
  },
  brand: {
    what_is_taxecobit: "Qu'est-ce que TaxEcoBit ?",
    taxecobit_description:
      "TaxEcoBit est une plateforme d'automatisation de la conformité conçue pour les entreprises affectées par le Mécanisme d'Ajustement des Frontières Carbone (CBAM) de l'UE. Nous aidons les importateurs, les fabricants et les PME à calculer les émissions de carbone au niveau des produits, à générer des rapports conformes au CBAM et à réduire les risques réglementaires.",
    taxecobit_benefits: "Avec TaxEcoBit, les utilisateurs peuvent :",
    benefit_accurate_calculations:
      "Effectuer des calculs carbone précis en utilisant des facteurs d'émission officiels et personnalisés",
    benefit_cbam_documents: "Générer des documents CBAM prêts à être soumis",
    benefit_carbon_cost_tracking:
      "Surveiller l'impact des coûts carbone et optimiser l'efficacité opérationnelle",
    benefit_api_integration:
      "Intégrer de manière transparente les flux de travail de conformité via l'API avec les systèmes ERP et de chaîne d'approvisionnement",
    taxecobit_conclusion:
      "En remplaçant les feuilles de calcul manuelles et la dépendance aux consultants, TaxEcoBit permet une conformité plus rapide et plus fiable à un coût opérationnel inférieur.",
  },
  userLevel: {
    label: "Niveau utilisateur",
    highest_level: "Niveau le plus élevé",
    next_level: "Niveau suivant : {level}",
    standard_user: "Utilisateur standard",
    bronze_user: "Utilisateur Bronze",
    silver_user: "Utilisateur Argent",
    gold_user: "Utilisateur Or",
    platinum_user: "Utilisateur Platine",
    bronze_next: "Bronze (50 calculs)",
    silver_next: "Argent (150 calculs)",
    gold_next: "Or (300 calculs)",
    platinum_next: "Platine (600 calculs)",
    highest_level_text: "Niveau le plus élevé atteint",
  },
  notification: {
    title: "Notifications",
    settings: "Paramètres de notification",
    preferences: "Préférences de notification",
    email_notifications: "Notifications par email",
    app_notifications: "Notifications d'application",
    all: "Toutes les notifications",
    important: "Notifications importantes uniquement",
    none: "Aucune notification",
    save_preferences: "Enregistrer les préférences de notification",
    success_message: "Préférences de notification enregistrées avec succès",
    error_message: "Échec de l'enregistrement des préférences de notification",
    detail_title: "Détails de la notification",
    mark_as_read: "Marquer comme lu",
    not_found_title: "Notification introuvable",
    not_found_desc: "La notification que vous recherchez n'existe pas ou a été supprimée.",
    search_placeholder: "Rechercher par titre ou contenu",
    email_sent: "Email envoyé",
    in_app_only: "Dans l'application",
    no_notifications: "Aucune notification",
    total: "Total {total} notifications",
    fetch_failed: "Échec de la récupération des notifications",
    marked_as_read: "Marqué comme lu avec succès",
    mark_failed: "Échec du marquage comme lu",
    mark_all_read: "Tout marquer comme lu",
    view_all: "Tout voir",
  },
  notFound: {
    title: "404 Introuvable",
    description: "Désolé, la page que vous avez visitée n'existe pas.",
    goHome: "Retour à l'accueil",
  },
  login: {
    sign_in: "Se connecter",
    sign_up: "S'inscrire",
    password_rule_length: "Au moins 8 caractères",
    password_rule_letter: "Contient des lettres anglaises",
    password_rule_number: "Contient des chiffres",
    password_rule_special: "Contient des caractères spéciaux {0}",
  },
};
